export const SUBSCRIPTIONS_ALL = 'SUBSCRIPTIONS_ALL';
export const SUBSCRIPTIONS_ALL_SUCCESS = 'SUBSCRIPTIONS_ALL_SUCCESS';
export const SUBSCRIPTIONS_GET = 'SUBSCRIPTIONS_GET';
export const SUBSCRIPTIONS_GET_SUCCESS = 'SUBSCRIPTIONS_GET_SUCCESS';
export const SUBSCRIPTIONS_CREATE = 'SUBSCRIPTIONS_CREATE';
export const SUBSCRIPTIONS_CREATE_SUCCESS = 'SUBSCRIPTIONS_CREATE_SUCCESS';
export const SUBSCRIPTIONS_UPDATE = 'SUBSCRIPTIONS_UPDATE';
export const SUBSCRIPTIONS_UPDATE_SUCCESS = 'SUBSCRIPTIONS_UPDATE_SUCCESS';
export const SUBSCRIPTIONS_DELETE = 'SUBSCRIPTIONS_DELETE';
export const SUBSCRIPTIONS_DELETE_SUCCESS = 'SUBSCRIPTIONS_DELETE_SUCCESS';